// Core collections / NFTs
export const HENLO_CARDS_ADDRESS = "0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC";
export const HENLO_PFP_ADDRESS = "0x0982c808B42A72d256d7E9d3BdF61e44ef31230d";

// Tokens (ERC‑20)
export const HENLO_ADDRESS = "0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5";
export const HONEY_ADDRESS = "0xFCBD14DC51f0A4d49d5E53C2E0950e0bC26d0Dce";
export const BGT_ADDRESS = "0x656b95E550C07a9ffe548bd4085c72418Ceb1dba";
export const OBERO_ADDRESS = "0x40A8d9efE6A2C6C9D193Cc0A4476767748E68133";

// Token groups (for convenience)
export const TOKEN_ADDRESSES = {
  HENLO: HENLO_ADDRESS,
  HONEY: HONEY_ADDRESS,
  BGT: BGT_ADDRESS,
  OBERO: OBERO_ADDRESS,
} as const;

// Vaults / protocol contracts
export const HENLO_VAULT_ADDRESS = "0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC";
export const HODL_MULTI_ADDRESS = "0x437F681fC3c71C21Eb3033a14b7590b4CDCA329B";
export const RESERVOIR_ADDRESSES: string[] = [];
export const AQUABERA_ADDRESS = "0xc0c6D4178410849eC9765B4267A73F4F64241832";
export const AQUABERA_HENLO_VAULT = "0x04fD6a7B02E2e48caedaD7135420604de5f834f8";
export const AQUABERA_HENLO_DEPLOYER = "0x9Fbba6c87923af2561A2391198166b51Cf5736E8";

// FDV contract information
export const FDV_CONTRACT_ADDRESS = "0xD5F76a363135A0781295043241f18496dAa31E3d";
export const FDV_SENDER_ADDRESS = "0x97de4fa69e79bd9b812111f12f38767ada36e58e";
export const FDV_KEY = "0xe427b23385fdae0c6d81a081ccf3a2811d01ee6c6d158c2d2b93e3746544857b";

export const GAUGE_20M_ADDRESS = "0x4c9c76d10b1Fa7D8f93bA54ab48E890fF0A7660D";
export const GAUGE_100M_ADDRESS = "0x4D615305Fe6c7A93e16c174D9076efEFbbA0C9A6";
export const GAUGE_330M_ADDRESS = "0x6A0dFE7c04346E5f718a1ecc24FAbe9ef57eDC0e";
export const GAUGE_420M_ADDRESS = "0x679fB5d465e082e398f1E05C0071E606A3651f55";
export const GAUGE_690M_ADDRESS = "0xE7F25F8C17D478e387756B588Bf7F32e9152bae6";
export const GAUGE_1B_ADDRESS = "0x7941Dd6fc9519514B185B5D3966f673F910E1e7d";

export const GAUGE_ADDRESSES: { address: `0x${string}`; label: string }[] = [
  { address: GAUGE_20M_ADDRESS as `0x${string}`, label: "Gauge 20M" },
  { address: GAUGE_100M_ADDRESS as `0x${string}`, label: "Gauge 100M" },
  { address: GAUGE_330M_ADDRESS as `0x${string}`, label: "Gauge 330M" },
  { address: GAUGE_420M_ADDRESS as `0x${string}`, label: "Gauge 420M" },
  { address: GAUGE_690M_ADDRESS as `0x${string}`, label: "Gauge 690M" },
  { address: GAUGE_1B_ADDRESS as `0x${string}`, label: "Gauge 1B" },
];

export const REWARD_VAULT_100M_ADDRESS = "0x8412561FADDD6C85F5a17e07E0F29428B813E69B";
export const REWARD_VAULT_330M_ADDRESS = "0xA713816E8d190EFdf35d66b723eb63f8c8c4d5D2";
export const REWARD_VAULT_420M_ADDRESS = "0x15970fcf2dbb9FfCC4e2f79c3Fd777B871540D5b";
export const REWARD_VAULT_690M_ADDRESS = "0x610b6A27A3A83Cea0574C5001F30d9EEA3699b1a";
export const REWARD_VAULT_1B_ADDRESS = "0xA6A3E6fb89FA4C6554e82D05b449639EeBfc564f";

export const REWARD_VAULT_AQUABERA_ADDRESS = "0x16e8031814e58f581c8a1d6e087458b5110879fa";

// Testnet
export const HENLO_TESTNET_ADDRESS = "0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be";
